import { getEnv } from 'common-nextjs';

/**
 * Impact Radius script code without loading the actual script.
 * This sets up capturing events until the real script loads.
 *
 * See also: ImpactTracker.tsx
 */
export function setupImpactLocalCapture() {
  if (window.ire) return;

  // @ts-ignore
  window.ire_o = 'ire';
  window.ire =
    window.ire ||
    function () {
      if (getEnv() !== 'production') {
        console.log(
          '[Impact Local] ire called with args:',
          Array.prototype.slice.call(arguments, 0),
        );
      }
      // @ts-ignore
      (window.ire.a = window.ire.a || []).push(arguments);
    };
}
